(ns minorodata.data-views.events
  (:require [minorodata.app.handlers :refer [reg-event-fx]]
            [re-posh.core :as re-posh]
            [minorodata.data-views.model :refer [->data-views-page]]))

(reg-event-fx
 :data-views.events/reset
 (fn []
   {:dispatch-n [[:data-views-all/add {:data-views-all/items-per-page 100 :data-views-all/page 1}]
                 [:data-views.api/fetch-all
                  {:page      nil
                   :order-by  "created_at"
                   :order-dir "desc"
                   :replace?  true}]]}))

(reg-event-fx
 :data-views.events/reset-shared
 (fn []
   {:dispatch-n [[:data-views-shared/add {:data-views-shared/items-per-page 100 :data-views-shared/page 1}]
                 [:data-views.api/fetch-shared
                  {:page      nil
                   :order-by  "created_at"
                   :order-dir "desc"
                   :replace?  true}]]}))

(reg-event-fx
 :data-views.events/reset-created
 (fn []
   {:dispatch-n [[:data-views-created/add {:data-views-created/items-per-page 100 :data-views-created/page 1}]
                 [:data-views.api/fetch-created
                  {:page      nil
                   :order-by  "created_at"
                   :order-dir "desc"
                   :replace?  true}]]}))

 (reg-event-fx
  :data-views.events/switch
  (fn [_]
    (let [page @(re-posh/subscribe [:data-views-page/pull])]
      {:dispatch-n
       [[:data-views-page/delete]
        [:data-views-page/add
         (->data-views-page (dissoc page :data-views-page/data))]]})))
